import React from 'react';
import { Link } from "react-router-dom";
import Header from "../components/Header";
import HomeHero from "../components/heroes/HomeHero";
// import HeroForm from '../components/HeroForm';
import ServiceHighlights from "../components/ServiceHighlights";
// import ServicesOverview from '../components/ServicesOverview';
// import InterestSection from '../components/InterestSection';
import SmartHomeSection from "../components/SmartHomeSection";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import { Reviews } from "../components/Reviews";
import SEO from "../components/SEO";

function Home() {
  return (
    <div className="min-h-screen bg-white page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Elektricien nodig in Arnhem? Direct bereikbaar - elektricieninarnhem026.nl"
        description="Op zoek naar een ervaren elektricien in Arnhem? elektricieninarnhem026.nl is direct bereikbaar voor alle elektra werkzaamheden. Betrouwbaar, snel en vakkundig in heel Nederland!"
        image="/images/banner.png"
      />
      <Header />
      <HomeHero />
      <ServiceHighlights />

      <SmartHomeSection />
      <FAQ />

      <Reviews />

      <PartnerMarquee />

      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#FFD100] transition-opacity duration-150 hover:opacity-80">
        <Link
          to="/offerte"
          aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Offerte aanvragen
            </div>
          </section>
        </Link>
      </div>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default Home;
